export default __webpack_public_path__ + "static/media/GetSupport.6ca6f1b8.svg";